import { makeStyles } from "@mui/styles";

export const useStyle = makeStyles({
  container: {
    display: "flex",
    flex: "1",
    background: "#FFFFFF",
    width: "100%",
    borderRadius: "42px 0px 0px 0px",
    padding: "70px 0 0 0px",
    boxShadow: "0px -12px 6px #00000029",
    flexDirection: "column",
    alignItems: "flex-start",
    overflow: "hidden",
  },
  listInfo: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    alignItems: "center",
    width: "100%",
    margin: "0 0 0 34px",
    padding: "0 0",
  },
  rootControleur: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    margin: "20px 0 0 35px",
  },
  boxButton: {
    display: "flex",
    justifyContent: "end",
    marginRight: "50px",
    width: "100%",
  },
});
